const BLOG_SEARCH_DEBOUNCE_MILLISECONDS = 350;


const BLOG_SEARCH_MINIMUM_LENGTH = 2;

const BLOG_SEARCH_RESULT_LIMIT = 10;

function getBlogSearchUrl(searchAction, baseUrl, queryValue, sectionId) {
  const searchUrl = new URL(searchAction, baseUrl);

  searchUrl.searchParams.set('q', queryValue);
  searchUrl.searchParams.set('resources[type]', 'article');
  searchUrl.searchParams.set('resources[limit]', String(BLOG_SEARCH_RESULT_LIMIT));
  searchUrl.searchParams.set('section_id', sectionId);

  return searchUrl.toString();
}

function getIsBlogQuerySearchable(queryValue) {
  return queryValue.trim().length >= BLOG_SEARCH_MINIMUM_LENGTH;
}

function initBlogSearch(rootElement) {
  if (rootElement.dataset.klBlogSearchReady === 'true') return;

  const formElement = rootElement.querySelector('[data-kl-blog-search-form]');
  const inputElement = rootElement.querySelector('[data-kl-blog-search-input]');
  const clearElement = rootElement.querySelector('[data-kl-blog-search-clear]');
  const resultsElement = rootElement.querySelector('[data-kl-blog-search-results]');
  const errorElement = rootElement.querySelector('[data-kl-blog-search-error]');
  const hiddenElements = rootElement.querySelectorAll('[data-kl-blog-search-hide]');
  const resultsSectionId = rootElement.dataset.klBlogSearchSection;
  const searchEndpoint = rootElement.dataset.klBlogSearchUrl;

  if (!formElement || !inputElement) return;

  if (!resultsElement || !resultsSectionId || !searchEndpoint) {
    console.debug('kl-blog-search: no results container, section or endpoint', {
      resultsSectionId,
      searchEndpoint,
    });
    return;
  }

  rootElement.dataset.klBlogSearchReady = 'true';

  let debounceTimeoutId = null;
  let activeRequest = null;

  function setErrorShown(isShown) {
    if (errorElement) errorElement.hidden = !isShown;
  }

  function showListing() {
    resultsElement.innerHTML = '';
    resultsElement.hidden = true;
    hiddenElements.forEach((hiddenElement) => {
      hiddenElement.hidden = false;
    });
  }

  function showResults(resultsMarkup) {
    setErrorShown(false);
    resultsElement.innerHTML = resultsMarkup;
    resultsElement.hidden = false;
    hiddenElements.forEach((hiddenElement) => {
      hiddenElement.hidden = true;
    });

    document.dispatchEvent(
      new CustomEvent('kl:content:added', { detail: { root: resultsElement } })
    );
  }

  async function runSearch(queryValue) {

    if (activeRequest) activeRequest.abort();

    const request = new AbortController();

    activeRequest = request;

    try {
      const response = await fetch(
        getBlogSearchUrl(searchEndpoint, rootElement.baseURI, queryValue, resultsSectionId),
        { signal: request.signal }
      );

      if (!response.ok) throw new Error(`Shopify answered ${response.status}`);

      showResults(await response.text());
    } catch (error) {
      if (error.name === 'AbortError') return;

      console.debug('kl-blog-search: could not fetch results', { queryValue, error });

      showListing();
      setErrorShown(true);
    } finally {
      if (activeRequest === request) activeRequest = null;
    }
  }

  function applyQuery() {
    const queryValue = inputElement.value;

    if (clearElement) clearElement.hidden = queryValue.length === 0;

    if (!getIsBlogQuerySearchable(queryValue)) {
      if (activeRequest) activeRequest.abort();
      showListing();
      setErrorShown(false);
      return;
    }

    runSearch(queryValue.trim());
  }

  inputElement.addEventListener('input', () => {
    if (debounceTimeoutId) clearTimeout(debounceTimeoutId);

    debounceTimeoutId = setTimeout(applyQuery, BLOG_SEARCH_DEBOUNCE_MILLISECONDS);
  });

  formElement.addEventListener('submit', (event) => {
    event.preventDefault();

    if (debounceTimeoutId) clearTimeout(debounceTimeoutId);

    applyQuery();
  });

  if (clearElement) {
    clearElement.addEventListener('click', () => {
      inputElement.value = '';

      if (debounceTimeoutId) clearTimeout(debounceTimeoutId);

      applyQuery();

      inputElement.focus();
    });
  }
  applyQuery();
}

document.querySelectorAll('[data-kl-blog-search]').forEach(initBlogSearch);

document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-kl-blog-search]').forEach(initBlogSearch);
});
